import ReactDOM from 'react-dom/client';
import App from './App';
import "./App.css";
import "./scss/index.scss";
import "./admin/styles/index.scss";


import { HelmetProvider } from 'react-helmet-async';

const rootElement = document.getElementById('root');

if (!rootElement) throw new Error('Root element not found');

const root = ReactDOM.createRoot(rootElement);
root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
);
